import {selectHasSilentRefetching} from '../createEagGridStore';
import {useEagGridSelector} from '../useEagGridSelector';

export function useHasSilentRefetching(): boolean {
  return useEagGridSelector(selectHasSilentRefetching);
}
